module.exports = __webpack_public_path__ + "static/megaphone-49dea14306b1dd116edde949641b8c68.png";